<adapt-feature-guidance [configItem]="configItem">
    <p>Set your preferred theme for {{ projectLabel }}.</p>
</adapt-feature-guidance>

<ng-container *adaptLoading="!person">
    <dx-select-box [dataSource]="options"
                   displayExpr="name"
                   valueExpr="value"
                   [(value)]="person!.preferences.themeId"
                   (valueChange)="updateTheme($event)"
                   labelMode="floating"> </dx-select-box>
</ng-container>
